import { isNewsItemIdResponseDTO } from "./NewsItemId";
import { NewsItemImageResponseApi } from "./NewsItemImage";

export interface NewsItemResponseApi {
  newsId: string;
  newsTitle: string;
  newsPreviewText: string;
  newsAuthor: string;
  newsHtml: string;
  newsDate: string;
  newsImages: NewsItemImageResponseApi[];
}

export let isNewsItemResponseDTO = (
  variable: unknown
): variable is NewsItemResponseApi => {
  return (
    isNewsItemIdResponseDTO(variable) &&
    "newsTitle" in variable &&
    typeof variable.newsTitle === "string" &&
    "newsPreviewText" in variable &&
    typeof variable.newsPreviewText === "string" &&
    "newsAuthor" in variable &&
    typeof variable.newsAuthor === "string" &&
    "newsHtml" in variable &&
    typeof variable.newsHtml === "string" &&
    "newsDate" in variable &&
    typeof variable.newsDate === "string" &&
    "newsImages" in variable &&
    Array.isArray(variable.newsImages) &&
    variable.newsImages.reduce(
      (doArrayConsistOfImages, newsItemImage: unknown) =>
        doArrayConsistOfImages && isNewsItemResponseDTO(newsItemImage),
      true
    )
  );
};

export class NewsItemPropImpl implements NewsItemResponseApi {
  newsId: string;
  newsTitle: string;
  newsPreviewText: string;
  newsDate: string;
  newsImages: NewsItemImageResponseApi[];

  constructor(newsData: {
    newsId: string;
    newsTitle: string;
    newsPreviewText: string;
    newsDate: string;
    newsImages: NewsItemImageResponseApi[];
  }) {
    this.newsId = newsData.newsId;
    this.newsTitle = newsData.newsTitle;
    this.newsPreviewText = newsData.newsPreviewText;
    this.newsDate = newsData.newsDate;
    this.newsImages = newsData.newsImages;
  }
  newsAuthor!: string;
  newsHtml!: string;
}

export class EmptyNewsItemPropImpl extends NewsItemPropImpl {
  newsHtml: string;
  newsAuthor: string;

  constructor() {
    super({
      newsId: "",
      newsTitle: "",
      newsPreviewText: "",
      newsDate: "",
      newsImages: [],
    });
    this.newsHtml = "";
    this.newsAuthor = "";
  }
}
